import { DmpConnectorSettings, DmpVisibility, SecurityLabelEnum } from '../types';

export function computeDmpVisibility(settings: DmpConnectorSettings): DmpVisibility {
  if (!settings.securityLabels || settings.securityLabels.length < 1)
    return DmpVisibility.VisibleForAll;

  if (settings.securityLabels.includes(SecurityLabelEnum.HideForPatient))
    return DmpVisibility.HideForPatient;

  if (settings.securityLabels.includes(SecurityLabelEnum.HideForProfessionals))
    return DmpVisibility.HideForProfessionals;

  if (settings.securityLabels.includes(SecurityLabelEnum.HideForParents))
    return DmpVisibility.HideForParents;

  return DmpVisibility.VisibleForAll;
}
